import { render, staticRenderFns } from "./IXP.vue?vue&type=template&id=1f1ab275&scoped=true&"
import script from "./IXP.vue?vue&type=script&lang=js&"
export * from "./IXP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1ab275",
  null
  
)

export default component.exports